module.exports = __webpack_public_path__ + "static/img/shopmall.062a9ecb.svg";